













import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';
import { BusinessBookingOptions } from '@/models/businesses/business-booking-options';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbIcon
    }
})
export default class EditBookingOptions extends Vue {
    @Prop(BusinessBookingOptions) private bookingOptions!: BusinessBookingOptions;
}
